import { Event } from 'three';
import { onPointerUpRoomDimensions } from '@/Engine/eventHandlers/roomDimensionChanging';
import { getIntersection, getSizingBoxesIntersection } from '@/Engine/intersections';
import { $ } from '@/Engine/state';
import { afterMoveHandler } from '@/Engine/eventHandlers/afterMoveHandler';
import { onClickSelection } from '@/Engine/eventHandlers/onClickSelection';
import { useUIOnlyStore } from '@/Store/storeUI';

export const onPointerUpHandler = (e: Event) => {
    if (useUIOnlyStore().mode === 1) {
        onPointerUpRoomDimensions(
            getSizingBoxesIntersection(), getIntersection([ $.room.ceilRaycastPlane ]));
    }
    $.wallPointer = null;
    $.shelfPlace = null;
    // Если двигали объект

    if ($.moved) {
        afterMoveHandler();
        return;
    }
    // Иначе пробуем выделить объект на сцене
    onClickSelection();

    $.dragging = false;
    $.mouseDown = false;
    $.app.controls.enabled = true;
    $.render();
};
